const Develop = theme => {
  return {
    background: {
      backgroundImage:
        'linear-gradient(to right top, #41495e, #4b677c, #578796, #6ca7a8, #8fc7b5)',
    },
    foreground: {
      // color: 'rgba(137,220,243,.7)',
      color: 'rgba(255,255,255,1)',
    },
    from: '#41495e',
    to: '#8fc7b5',
  }
}

export default Develop



// WEBPACK FOOTER //
// ./src/styles/mixins/gradients/develop.js